const redirectTo404 = () => window.location.replace("/page-not-found");

export default redirectTo404;
